import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import Disturbances from '../Disturbances/Disturbances'

const Counter: React.FC<{
    station: string
}> = ({ station }) => {
    const UPDATE_RATE = 15 // in seconds (ish)

    // Handle seconds count
    const [count, setCount] = useState<number>(0)

    const updateCounter = () => {
        setCount(prev => (prev < UPDATE_RATE ? prev + 1 : 0))
    }

    useEffect(() => {
        const timer = setInterval(() => updateCounter(), 1000)
        return () => clearInterval(timer)
    })

    return (
        <CounterWrapper>
            <Disturbances station={station} count={count} />
        </CounterWrapper>
    )
}

export default Counter

const CounterWrapper = styled.div``
